export default class Role {
  createdDatetime: string;
  id: string;
  name: string;
}



// WEBPACK FOOTER //
// ./src/models/system-admin/roles.ts